import { useSelector } from 'react-redux';
import { selectAdAccounts } from '@mm/state/selectors/adAccountsSelecotrs';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { useAdAccountCRUDActions } from '@mm/state/actions/AdAccountCRUDActions';
import AdAccountModel from '@mm/state/model/AdAccountModel';
import { useState } from 'react';

export const renderAdAccountName = (a: AdAccountModel) =>
  `${a.name || ''} (${a.id.toString()})`;

export const useAdAccount = () => {
  const remoteAdAccounts = useSelector(selectAdAccounts);

  const fbPageId = useSelector(activeFacebookPageIdSelector);

  const adAccountCRUDActions = useAdAccountCRUDActions();

  const [facebookPageAdAccounts, setFacebookPageAdAccounts] = useState<
    AdAccountModel[]
  >([]);

  const fetchFacebookPageAdAccounts = async () => {
    const accounts = await adAccountCRUDActions.retrieveByFbPageId(fbPageId);
    setFacebookPageAdAccounts(accounts);
  };

  const fetchRemoteAdAccounts = () => {
    adAccountCRUDActions.retrieveAll(fbPageId, false, '', false);
  };

  const changeAccount = async (adAccount: AdAccountModel) => {
    await adAccountCRUDActions.assignAdAccount(fbPageId, adAccount, true);
  };

  return {
    remoteAdAccounts,
    facebookPageAdAccounts,
    renderAdAccountName,
    changeAccount,
    fetchFacebookPageAdAccounts,
    fetchRemoteAdAccounts,
  };
};
